import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { ConnectionService } from 'ng-connection-service';

@Injectable({
    providedIn: 'root'
})
export class ConnectivityMonitorService {
    private isConnected$ = new BehaviorSubject<boolean>(navigator.onLine);
    private isOffline = false;

    constructor(
        private connectionService: ConnectionService,
        private toast: ToastrService
    ) {
        this.connectionService.monitor().subscribe((isConnected) => {
            this.isConnected$.next(isConnected.hasNetworkConnection);
            this.handleConnectionToast(isConnected.hasNetworkConnection);
        });
    }

    public get connectionStatus$(): Observable<boolean> {
        return this.isConnected$.asObservable();
    }

    public get isConnected(): boolean {
        return this.isConnected$.value;
    }

    private handleConnectionToast(isConnected: boolean) {
        if (isConnected && this.isOffline) {
            this.toast.clear();
            this.toast.success('You are back online!', '', {
                timeOut: 6000,
                positionClass: 'toast-top-right',
                easing: 'ease-in-out',
                closeButton: false,
                toastClass: 'ngx-toastr custom-toastr',
            });
            this.isOffline = false;
        } else if (!isConnected && !this.isOffline) {
            this.toast.error('You are offline!', '', {
                disableTimeOut: true,
                positionClass: 'toast-top-right',
                easing: 'ease-in-out',
                closeButton: false,
                toastClass: 'ngx-toastr custom-toastr',
            });
            this.isOffline = true;
        }
    }
}
